import Vue from "vue";
import VueLocalStorage from "vue-local-storage";

Vue.use(VueLocalStorage, {
  name: "smartbooks-ls"
});

export default {
  customer: {
    type: Object
  },
  invoice: {
    type: Object
  },
  recurringInvoice: {
    type: Object
  },
  creditNote: {
    type: Object
  }
};
